<template>
    <div class="spin_parent">
        <Table size="small" :loading="spin" :disabled-hover="true" :columns="columns" :data="data"></Table>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { GetMachinesByDiscount, UnbindMachineDiscount } from '@/api/discount'

export default {
  props: {
    row: Object
  },
  data () {
    return {
      spin: false,
      data: [],
      columns: [
        { title: '编号', key: 'id' },
        { title: '序列号', key: 'sn' },
        { title: '合作伙伴', key: 'agent_name' },
        { title: '站点', key: 'site_name' },
        { title: '地址', key: 'address' },
        {
          title: '操作',
          width: 120,
          key: 'operate',
          render: (h, data) => {
            return h('Button', {
              props: { type: 'warning', size: 'small', ghost: true },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '解绑活动',
                    content: `是否将活动: ${this.row.name},从该设备上解除?`,
                    onOk: () => {
                      this.unBind(data.row.id)
                    }
                  })
                }
              }
            }, '解绑')
          }
        }
      ]
    }
  },
  mounted () {
    this.spin = true
    GetMachinesByDiscount({ discount_id: this.row.id }).then(res => {
      const result = res.data
      console.log('result', result)
      this.data = result.data || []
      this.spin = false
    }).catch(err => {
      this.spin = false
      this.$Message.error('获取设备列表失败')
    })
  },
  methods: {
    unBind (machineId) {
      UnbindMachineDiscount({ machine_id: machineId, discount_id: this.row.id }).then(res => {
        const result = res.data
        if (result.status) {
          this.$Message.success('解绑成功')
          // 重新获取数据以确保数据是最新的
          this.refreshData()
        } else {
          this.$Message.error(result.msg || '解绑失败')
        }
      }).catch(err => {
        this.$Message.error('解绑失败')
      })
    },
    refreshData () {
      this.spin = true
      GetMachinesByDiscount({ discount_id: this.row.id }).then(res => {
        const result = res.data
        this.data = result.data || []
        this.spin = false
      }).catch(err => {
        this.spin = false
        this.$Message.error('获取设备列表失败')
      })
    }
  }
}
</script>

<style scoped>
.spin_parent {
    position: relative;
}

.spin {
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
}
</style>
